import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an error", error, errorInfo);
  }

  handleSignOut = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    localStorage.removeItem("permissions");
    window.location.href = "/login";
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column align-items-center justify-content-center vh-100 bg-light text-center p-4">
          <div className="card shadow-sm border-0" style={{ maxWidth: "500px" }}>
            <div className="card-body p-5">
              <div className="display-1 text-danger mb-4">
                <i className="bi bi-exclamation-triangle"></i>
              </div>
              <h2 className="fw-bold mb-3">Something went wrong</h2>
              <p className="text-muted mb-4">
                The application encountered an unexpected error. Please try refreshing the page or contact support if the problem persists.
              </p>
              <div className="d-flex gap-2 justify-content-center flex-wrap">
                <button
                  className="btn btn-primary px-4 py-2"
                  onClick={() => window.location.reload()}
                >
                  <i className="bi bi-arrow-clockwise me-2"></i>
                  Refresh Page
                </button>
                <button
                  className="btn btn-outline-secondary px-4 py-2"
                  onClick={this.handleSignOut}
                >
                  Sign Out & Sign In Again
                </button>
              </div>
              <p className="text-muted small mt-3 mb-0">
                If refreshing doesn't help, your session may be stale — try signing out and back in.
              </p>
              {process.env.NODE_ENV === "development" && (
                <div className="mt-4 text-start">
                  <details className="small text-danger">
                    <summary className="cursor-pointer">Error Details</summary>
                    <pre className="mt-2 bg-white p-2 border rounded overflow-auto" style={{ maxHeight: "200px" }}>
                      {this.state.error?.toString()}
                    </pre>
                  </details>
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
